module.exports = __webpack_public_path__ + "assets/385cecd84e250f8b2c2973eca87afbd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channels/ro/4.png
// module id = 353
// module chunks = 1